export class PasswordChangeModel {
    oldPassword: string;
    newPassword: string;
}

export class PasswordSetModel {
    consumerPassword: string;
    confirmConsumerPassword: string;
}